import React from 'react'
import { useSelector } from 'react-redux'
import { selectFeatureFlag } from '../../features/featureFlags/selectors'
import { DROPDOWN_SEARCH } from '../../config/featureFlagKeys'
import { DropdownSearchContext } from './DropdownSearchContext'

const DropdownSearchProvider = ({ staffArea, children }) => {
  const flagOn = useSelector(selectFeatureFlag(DROPDOWN_SEARCH))

  return (
    <DropdownSearchContext.Provider value={Boolean(staffArea && flagOn)}>
      {children}
    </DropdownSearchContext.Provider>
  )
}

export default DropdownSearchProvider
